import { Component, OnInit } from '@angular/core';
import { Lang } from 'src/app/Constants/app.model';
import { DataService } from 'src/app/data.service';
import { ContentDataResolver } from 'src/app/resolvers/contentdata.resolver';

declare var Genesys: any; // <-- allow use of global Genesys object

@Component({
  selector: 'app-covid-resources',
  templateUrl: './covid-resources.component.html',
  styleUrls: ['./covid-resources.component.scss']
})
export class CovidResourcesComponent implements OnInit {
  accordion: string;
  preventioncontent: string;
  subContent: string;
  currentLang: Lang = 'en';
  currentRouteMap: any;
  constructor(private services: ContentDataResolver, private readonly dataService: DataService) {
    this.dataService.selectedLang.subscribe(lang => {
      this.currentLang = lang;
    });
    this.dataService.currentRouteMap.subscribe(routeMap => {
      this.currentRouteMap = routeMap;
    });
  }

ngOnInit(): void {
    this.subContent = '';
     if (this.currentLang === 'en') {
      this.dataService.getDynamicContentData().subscribe(res => {
        if (res && Array.isArray(res)) {
          let data = res.find((ele: any) => ele.id === 129);
          if (data) {
           this.accordion = data.content.rendered;
           this.preventioncontent = data.content.rendered;
          }
        }
      });
    }else {
      this.dataService.getCovidResourceData().subscribe(res => {
        if (res) {
          this.accordion = res.content?.rendered;
           this.preventioncontent = res.content?.rendered;
        }
      });
    }
}


  // ngOnInit(): void {
  //   this.subContent = '';
  //   this.services.contentData.subscribe(res => {
  //     if (res) {
  //       let data = res.find((ele: any) => ele.id === 129);
  //       this.accordion = data.content.rendered;
  //       this.preventioncontent = data.content.rendered;
  //     }
  //   });
  // }

  openMessenger() {
    try {
      Genesys('subscribe', 'Messenger.ready', () => {
        Genesys(
          'command',
          'Messenger.open',
          {},
          () => {
            console.log('Messenger opened');
          },
          (error: any) => {
            console.error("Couldn't open messenger.", error);
          }
        );
      });
    } catch (err) {
      console.error('Genesys Messenger is not initialized yet.', err);
    }
  }
}
